import React, {Component} from 'react';
import Video from './Video';

class Section extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return this.props.imageClass
      ? <section id={ this.props.id } className={ this.props.className }>
          <div className="container">
            <div className="row">
              <div className={ this.columnCssClass }>
                { this.props.children }
              </div>
              <div className={ this.props.imageClass }><Video src={ this.props.src } /></div>
            </div>
          </div>
        </section>
      : <section id={ this.props.id } className={ this.props.className }>
          <div className="container">
            <div className="row">
              { this.props.children }
            </div>
          </div>
        </section>
  }
}

Section.defaultProps = {
    className: "section"
};

export default Section;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Section.jsx
 **/